//Backend access
import { useQueries } from '@tanstack/react-query';
import bksAPI from "services/api/bks"
import PropTypes from "prop-types";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useMemo } from "react";
import LiveViewDisplay from './display';
import { loadingScreen } from 'utils/wrapper';
import SoftBox from 'components/SoftComponents/SoftBox';

function LiveView({ device, nexus_id, deviceLayout, isPerspectiveLiveview = false, perspectiveAdjustment = false, isPreview = false }) {
  bksAPI.loadToken(useAuth0());

  const uuids = device.hardware_type == "visionect" ? device.uuids : [device.uuid];

  const liveviews = useQueries({
    queries: uuids.map((uuid) => ({
      queryKey: ['getLiveView', uuid, nexus_id],
      queryFn: async () => {
        return await bksAPI.getLiveView(uuid, nexus_id);
      },
      refetchInterval: 20 * 1000,
      staleTime: 0
    }))
  });

  const isLoading = liveviews.some((lv) => lv.isLoading);
  const error = liveviews.find((lv) => lv.error)?.error;

  const memoizedData = useMemo(() => {
    const readyViews = liveviews.filter(lv => lv.data);

    const liveview_urls = readyViews.map((lv) =>
      URL.createObjectURL(new Blob([lv.data]))
    );

    return {
      url: liveview_urls,
      cleanup: () => liveview_urls.forEach(url => URL.revokeObjectURL(url))
    };
  }, [liveviews.map(lv => lv.dataUpdatedAt).join('-')]);

  useEffect(() => {
    return () => memoizedData.cleanup();
  }, [memoizedData]);

  if (isLoading) {
    return (
      <SoftBox display="flex" justifyContent="center" alignItems="center" width="100%">
        {loadingScreen(deviceLayout)}
      </SoftBox>
    );
  }
  if (error) return "Error! " + error.message;

  return <LiveViewDisplay liveviews={memoizedData} {...{ device, deviceLayout, isPerspectiveLiveview, perspectiveAdjustment, isPreview }} />
}

// Typechecking props for the LiveView
LiveView.propTypes = {
  device: PropTypes.object,
  nexus_id: PropTypes.string,
  deviceLayout: PropTypes.string,
  isPerspectiveLiveview: PropTypes.bool,
  perspectiveAdjustment: PropTypes.bool,
  isPreview: PropTypes.bool,
};

export default LiveView;
